import ElementVideo from './ElementVideo';

export default ElementVideo;
export * from './ElementVideo';
